(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[83628,61971,93812],{

/***/ 93812:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_Illustration; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var node_modules_classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(node_modules_classnames);
// EXTERNAL MODULE: ./UI/components/Illustration/utils/helpers.js
var helpers = __webpack_require__(45783);
// EXTERNAL MODULE: ./UI/components/Illustration/styles.module.scss
var styles_module = __webpack_require__(31890);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/components/Illustration/utils/useIllustration.js





/* harmony default export */ function useIllustration(_param) {
    var src = _param.src, isStatic = _param.isStatic, classnames = _param.className, _lazyBoundary = _param.lazyBoundary, lazyBoundary = _lazyBoundary === void 0 ? "700px" : _lazyBoundary, apiParams = _param.apiParams, transparent = _param.transparent, placeholderProp = _param.placeholder, priority = _param.priority, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "src",
        "isStatic",
        "className",
        "lazyBoundary",
        "apiParams",
        "transparent",
        "placeholder",
        "priority"
    ]);
    var loader = isStatic ? function(param) {
        var staticSrc = param.src;
        return staticSrc;
    } : function(args) {
        return (0,helpers/* getContentfulImage */.t)((0,_object_spread/* default */.Z)({
            transparent: transparent
        }, args, apiParams));
    };
    var className = classnames_default()((styles_module_default()).image, classnames);
    var lazyProps = !priority ? {
        placeholder: placeholderProp || (transparent ? "blur" : "empty"),
        blurDataURL: (0,helpers/* getContentfulImage */.t)({
            src: src,
            quality: 1,
            format: "webp",
            transparent: transparent
        })
    } : {};
    return (0,_object_spread/* default */.Z)({
        src: src,
        loader: loader,
        className: className,
        lazyBoundary: lazyBoundary,
        priority: priority
    }, lazyProps, rest);
};

;// CONCATENATED MODULE: ./UI/components/Illustration/index.jsx








var Illustration = /*#__PURE__*/ (0,react.memo)(function(props) {
    var _ref = useIllustration(props), className = _ref.className, style = _ref.style, containerClasses = _ref.containerClasses, restProps = (0,_object_without_properties/* default */.Z)(_ref, [
        "className",
        "style",
        "containerClasses"
    ]);
    if (!(restProps === null || restProps === void 0 ? void 0 : restProps.src) || restProps.placeholder === "blur" && !restProps.blurDataURL) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("picture", {
        className: classnames_default()(className, containerClasses),
        style: style,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), (0,_object_spread/* default */.Z)({}, restProps))
    });
});
Illustration.defaultProps = {
    layout: "fill",
    alt: "",
    transparent: false,
    apiParams: {}
};
Illustration.propTypes = {
    transparent: (prop_types_default()).bool,
    // For more props check https://nextjs.org/docs/api-reference/next/legacy/image
    src: (prop_types_default()).string.isRequired,
    alt: (prop_types_default()).string,
    layout: prop_types_default().oneOf([
        "fill",
        "intrinsic",
        "fixed",
        "responsive", 
    ]),
    placeholder: prop_types_default().oneOf([
        "blur",
        "empty", 
    ]),
    // Check https://www.contentful.com/developers/docs/references/images-api/ for detailed api
    apiParams: prop_types_default().instanceOf(Object)
};
/* harmony default export */ var components_Illustration = (Illustration);


/***/ }),

/***/ 61971:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96076);
/* eslint-disable react/destructuring-assignment */ 




var ScrollAnimation = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(45003), __webpack_require__.e(68741)]).then(__webpack_require__.bind(__webpack_require__, 68741));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(68741)
            ];
        }
    }
});
var Reveal = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 8365).then(__webpack_require__.t.bind(__webpack_require__, 8365, 23)).then(function(module) {
        return module.default;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(8365)
            ];
        }
    }
});
var Fade = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 19470).then(__webpack_require__.t.bind(__webpack_require__, 19470, 23)).then(function(module) {
        return module.default;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(19470)
            ];
        }
    }
});
var CSSAnimation = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 90959).then(__webpack_require__.bind(__webpack_require__, 90959)).then(function(module) {
        return module.CSSAnimation;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(90959)
            ];
        }
    }
});
var ImageZoom = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 16626).then(__webpack_require__.bind(__webpack_require__, 16626));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(16626)
            ];
        }
    }
});
var Gsap = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 94744).then(__webpack_require__.bind(__webpack_require__, 94744)).then(function(module) {
        return module.Gsap;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(94744)
            ];
        }
    }
});
var ParallaxWrapper = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(14869), __webpack_require__.e(11897)]).then(__webpack_require__.bind(__webpack_require__, 11897));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(11897)
            ];
        }
    }
});
var ExpandWrapper = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 68376).then(__webpack_require__.bind(__webpack_require__, 68376)).then(function(module) {
        return module.ExpandWrapper;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(68376)
            ];
        }
    }
});
var CustomAnimation = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 52612).then(__webpack_require__.bind(__webpack_require__, 52612)).then(function(module) {
        return module.CustomAnimation;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(52612)
            ];
        }
    }
});
var JSONAnimation = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 25845).then(__webpack_require__.bind(__webpack_require__, 25845)).then(function(module) {
        return module.JSONAnimation;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(25845)
            ];
        }
    }
});
var Bounce = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 94803).then(__webpack_require__.t.bind(__webpack_require__, 94803, 23));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(94803)
            ];
        }
    }
});
var CounterAnimation = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(14869), __webpack_require__.e(78162)]).then(__webpack_require__.bind(__webpack_require__, 78162));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(78162)
            ];
        }
    }
});
var ZoomOut = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(14869), __webpack_require__.e(30730)]).then(__webpack_require__.bind(__webpack_require__, 30730));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(30730)
            ];
        }
    }
});
var Animated = function(props) {
    switch(props.type){
        case utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .ANIMATED_TYPE.isReveal */ .BK.isReveal:
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Reveal, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
                    children: props.children
                }));
            }
        case utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .ANIMATED_TYPE.isFade */ .BK.isFade:
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Fade, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
                    children: props.children
                }));
            }
        case utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .ANIMATED_TYPE.isCustom */ .BK.isCustom:
            {
                if (Object.keys(props).length === 1) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        children: props.children
                    });
                }
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CustomAnimation, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
                    children: props.children
                }));
            }
        case utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .ANIMATED_TYPE.isJSON */ .BK.isJSON:
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(JSONAnimation, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
                    children: props.children
                }));
            }
        case utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .ANIMATED_TYPE.isParallaxSpring */ .BK.isParallaxSpring:
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ParallaxWrapper, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
                    children: props.children
                }));
            }
        case utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .ANIMATED_TYPE.imageZoom */ .BK.imageZoom:
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ImageZoom, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
                    children: props.children
                }));
            }
        case utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .ANIMATED_TYPE.gsap */ .BK.gsap:
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Gsap, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
                    children: props.children
                }));
            }
        case utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .ANIMATED_TYPE.expandByHeight */ .BK.expandByHeight:
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ExpandWrapper, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
                    children: props.children
                }));
            }
        case utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .ANIMATED_TYPE.isCSS */ .BK.isCSS:
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CSSAnimation, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
                    children: props.children
                }));
            }
        case utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .ANIMATED_TYPE.bounce */ .BK.bounce:
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Bounce, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        children: props.children
                    })
                }));
            }
        case utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .ANIMATED_TYPE.counter */ .BK.counter:
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CounterAnimation, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
                    children: props.children
                }));
            }
        case utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .ANIMATED_TYPE.zoomOut */ .BK.zoomOut:
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ZoomOut, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
                    children: props.children
                }));
            }
        default:
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ScrollAnimation, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
                    children: props.children
                }));
            }
    }
};
/* harmony default export */ __webpack_exports__["default"] = (Animated);


/***/ }),

/***/ 53435:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ sections_ImagesSection; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./components/BlogCommon/Article/ContentfulParser/index.jsx
var ContentfulParser = __webpack_require__(92870);
// EXTERNAL MODULE: ./UI/components/SectionTitle/index.jsx
var SectionTitle = __webpack_require__(15805);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./components/CaseStudiesCommon/utils/data.js
var data = __webpack_require__(27515);
// EXTERNAL MODULE: ./UI/components/Media/index.jsx + 2 modules
var Media = __webpack_require__(34190);
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(96076);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
;// CONCATENATED MODULE: ./UI/components/Images/utils/useImages.js

var useImages = function(param) {
    var data = param.data, type = param.type, view = param.view;
    var ref, ref1;
    var images = get_default()(data, "images");
    var links = (ref1 = (ref = get_default()(data, "contentModules")) === null || ref === void 0 ? void 0 : ref.filter(function(module) {
        return module.sys.contentType.sys.id === "link";
    })) === null || ref1 === void 0 ? void 0 : ref1.map(function(module) {
        var ref;
        return (ref = module.fields) === null || ref === void 0 ? void 0 : ref.url;
    });
    return {
        type: type,
        view: view,
        images: images,
        links: links
    };
};

// EXTERNAL MODULE: ./UI/components/Images/styles.module.scss
var styles_module = __webpack_require__(56146);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ./UI/components/LinkWrapper/index.jsx + 2 modules
var LinkWrapper = __webpack_require__(56362);
;// CONCATENATED MODULE: ./UI/components/Images/index.jsx














var Animated = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 61971));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(61971)
            ];
        }
    }
});
var Images = function(_param) {
    var renderVideoPlayer = _param.renderVideoPlayer, props = (0,_object_without_properties/* default */.Z)(_param, [
        "renderVideoPlayer"
    ]);
    var ref = useImages(props), type = ref.type, view = ref.view, images = ref.images, links = ref.links;
    if (!images) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data/* ANIMATION_CASE_STUDY_PROPS */.e), {
        delay: 50,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: classnames_default()((styles_module_default())[type], (styles_module_default())[view], (styles_module_default()).container, (links === null || links === void 0 ? void 0 : links.length) > 0 && (styles_module_default()).imageLinkContainer),
            children: images === null || images === void 0 ? void 0 : images.map(function(asset, index) {
                var link = links === null || links === void 0 ? void 0 : links[index];
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated, {
                    type: constants/* ANIMATED_TYPE.isCSS */.BK.isCSS,
                    intersectedClasses: classnames_default()((0,_define_property/* default */.Z)({}, (styles_module_default()).active, index)),
                    children: link ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWrapper/* default */.Z, {
                        path: link,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Media["default"], {
                            priority: true,
                            transparent: true,
                            unoptimized: true,
                            asset: asset,
                            renderVideoPlayer: renderVideoPlayer,
                            className: classnames_default()((styles_module_default()).image, (styles_module_default()).imageLink, (styles_module_default())["image-".concat(index + 1)]),
                            displayParams: {
                                format: "webp"
                            }
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Media["default"], {
                        priority: true,
                        transparent: true,
                        unoptimized: true,
                        asset: asset,
                        renderVideoPlayer: renderVideoPlayer,
                        className: classnames_default()((styles_module_default()).image, (styles_module_default())["image-".concat(index + 1)])
                    })
                }, "image-".concat(index));
            })
        })
    }));
};
Images.defaultProps = {
    type: "imageContainer",
    view: "",
    isMobileResolution: false
};
Images.propTypes = {
    data: prop_types_default().instanceOf(Object).isRequired,
    isMobileResolution: (prop_types_default()).bool,
    type: (prop_types_default()).string,
    view: (prop_types_default()).string,
    renderVideoPlayer: (prop_types_default()).func
};
/* harmony default export */ var components_Images = (Images);

// EXTERNAL MODULE: ./UI/components/Illustration/index.jsx + 1 modules
var Illustration = __webpack_require__(93812);
// EXTERNAL MODULE: ./UI/containers/Animated/index.jsx
var containers_Animated = __webpack_require__(61971);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(6572);
// EXTERNAL MODULE: ./UI/sections/ImagesSection/styles.module.scss
var ImagesSection_styles_module = __webpack_require__(70976);
var ImagesSection_styles_module_default = /*#__PURE__*/__webpack_require__.n(ImagesSection_styles_module);
;// CONCATENATED MODULE: ./UI/sections/ImagesSection/utils/useImageSection.js




var useImageSection = function(param) {
    var data = param.data, type = param.type;
    var title = data.title, subtitle = data.subtitle, description = data.description, contentModules = data.contentModules, background = data.background;
    var imagesBundles = (0,helper/* getDocumentFields */.OA)(get_default()(data, "contentModules[0]"), [
        "imagesBundles"
    ]).imagesBundles;
    var imagesUrl = imagesBundles === null || imagesBundles === void 0 ? void 0 : imagesBundles.map(function(image) {
        return (0,helper/* getImage */.gJ)(image);
    });
    var backgroundImage = background && (0,helper/* getImage */.gJ)(background);
    var text = (0,helper/* getDocumentFields */.OA)(get_default()(contentModules, "[0]", {}), [
        "text"
    ]).text;
    var sectionTitles = {
        type: type,
        title: title,
        subtitle: subtitle,
        description: description,
        titleStyle: (ImagesSection_styles_module_default()).titleStyle
    };
    var sectionProps = {
        className: classnames_default()((ImagesSection_styles_module_default())[type], (ImagesSection_styles_module_default())[data.view], (ImagesSection_styles_module_default()).section),
        style: backgroundImage ? {
            backgroundImage: "url(".concat(backgroundImage.url, ")")
        } : {}
    };
    return {
        sectionTitles: sectionTitles,
        type: type,
        data: data,
        imagesUrl: imagesUrl,
        text: text,
        sectionProps: sectionProps
    };
};

;// CONCATENATED MODULE: ./UI/sections/ImagesSection/index.jsx













var VideoPlayer = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 62387).then(__webpack_require__.bind(__webpack_require__, 62387));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(62387)
            ];
        }
    }
});
var ImagesSection = function(props) {
    var ref = useImageSection(props), data = ref.data, type = ref.type, imagesUrl = ref.imagesUrl, text = ref.text, sectionProps = ref.sectionProps, sectionTitles = ref.sectionTitles;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, sectionProps), {
        children: [
            imagesUrl === null || imagesUrl === void 0 ? void 0 : imagesUrl.map(function(param) {
                var url = param.url, alt = param.alt;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Illustration["default"], {
                    transparent: true,
                    className: (ImagesSection_styles_module_default()).bundleImage,
                    src: url,
                    alt: alt
                }, "intro-images-bundles/".concat(url));
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTitle["default"], (0,_object_spread/* default */.Z)({}, sectionTitles)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Images, {
                data: data,
                type: type,
                view: data.view,
                renderVideoPlayer: function(param) {
                    var src = param.src, description = param.description;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoPlayer, {
                        src: src,
                        description: description,
                        withBlackout: true,
                        classes: {
                            container: (ImagesSection_styles_module_default()).videoContainer,
                            videoWrapper: (ImagesSection_styles_module_default()).videoWrapper,
                            description: (ImagesSection_styles_module_default()).videoDescription
                        }
                    });
                }
            }),
            text && /*#__PURE__*/ (0,jsx_runtime.jsx)(containers_Animated["default"], (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, constants/* REVEAL_ANIMATION_PROPS */.kt), {
                transitionDelay: 50,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (ImagesSection_styles_module_default()).textContainer,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentfulParser["default"], {
                        document: text
                    })
                })
            }))
        ]
    }));
};
ImagesSection.prototype = {
    data: prop_types_default().instanceOf(Object).isRequired,
    type: (prop_types_default()).string.isRequired
};
/* harmony default export */ var sections_ImagesSection = (ImagesSection);


/***/ }),

/***/ 27515:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ ANIMATION_CASE_STUDY_PROPS; }
/* harmony export */ });
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96076);

var ANIMATION_CASE_STUDY_PROPS = {
    type: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ANIMATED_TYPE.isFade */ .BK.isFade,
    duration: 1000
};


/***/ }),

/***/ 31890:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"image":"styles_image__T17hn"};

/***/ }),

/***/ 56146:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3fVC3","image":"styles_image__zS5Xl","scaled":"styles_scaled___TtZd","stickerbox":"styles_stickerbox__5jPtu","firstSectionView":"styles_firstSectionView__X8X3P","secondSectionView":"styles_secondSectionView__mZPHu","fairy":"styles_fairy__piri0","fernwayer":"styles_fernwayer__n_jRv","thirdSectionView":"styles_thirdSectionView__9SM3u","drive-focus":"styles_drive-focus__isv7v","hotel-data-cloud":"styles_hotel-data-cloud__JLjct","open-sense":"styles_open-sense__7C5O7","separate-us":"styles_separate-us__gwSu0","famlicious":"styles_famlicious__nTlHM","natp":"styles_natp__CQuMZ","image-1":"styles_image-1__mhec8","image-2":"styles_image-2__9e0pW","travel-trivia":"styles_travel-trivia__ki6a8","tell":"styles_tell__MXiV1","ubichat":"styles_ubichat__I2N5Z","writer-chrome-extension":"styles_writer-chrome-extension__RSWAX","meateater":"styles_meateater__ftAKl","bionorica":"styles_bionorica__UCMPe","marketplace-for-clairvoyant-services":"styles_marketplace-for-clairvoyant-services__aqF_b","fusion-markets":"styles_fusion-markets__pshwz","beautonomy":"styles_beautonomy__BfpoA","telemojo":"styles_telemojo__iwAhd","blackbird":"styles_blackbird__9sgw4","fintech-app-for-credit-score":"styles_fintech-app-for-credit-score__VfmXC","smartcenter":"styles_smartcenter__ezFrU","dindon":"styles_dindon__qRRcB","humankind":"styles_humankind__TgrUp","cinnabar":"styles_cinnabar__q5Jag","machine-learning-in-real-estate":"styles_machine-learning-in-real-estate__KRC3p","mobile-bank-application":"styles_mobile-bank-application__G1bgD","software-for-mri-interpretation":"styles_software-for-mri-interpretation__oJBFQ","cedar-valley-farms":"styles_cedar-valley-farms__dy_eU","why-us":"styles_why-us__RUrmr","fourthSectionView":"styles_fourthSectionView__ZDwAS","fifthSectionView":"styles_fifthSectionView__sei4t","sixthSectionView":"styles_sixthSectionView__3nRTR","mobile-budgeting-app":"styles_mobile-budgeting-app__J5EU3","forex-trading-platform":"styles_forex-trading-platform__G8P6z","crowdfunding-platform":"styles_crowdfunding-platform__5U_rn","cctv-footage-analytics":"styles_cctv-footage-analytics__eAn7C","analytics-for-carbon-tracking":"styles_analytics-for-carbon-tracking__SK_Nf","web-chat-for-mediums":"styles_web-chat-for-mediums__gXIvF","web-p2p-lending-platform":"styles_web-p2p-lending-platform__JcNxi","image-3":"styles_image-3__J5DIz","kitchen-equipment-customizer":"styles_kitchen-equipment-customizer__Ie5_V","mobile-music-app":"styles_mobile-music-app__drSX_","seventhSectionView":"styles_seventhSectionView__j1yb_","digital-wallet-for-ios":"styles_digital-wallet-for-ios__gMLl7","enterprise-resource-planning-system":"styles_enterprise-resource-planning-system__GjLrh","seven-pm-thursday":"styles_seven-pm-thursday__R7wP_","company":"styles_company__iGKBe","ai-documentation-processing":"styles_ai-documentation-processing__0EBmR","enhancing-money-laundering-mention-extraction":"styles_enhancing-money-laundering-mention-extraction__7jXU4","web-logistics-platform":"styles_web-logistics-platform__rTenL","llm-legal-document-summarization":"styles_llm-legal-document-summarization__ArBAE","titleStyle":"styles_titleStyle__UBw1g","ai-feedback-analysis":"styles_ai-feedback-analysis__uF45U","ai-for-edtech":"styles_ai-for-edtech__BX2bh","ai-reporting-assistant":"styles_ai-reporting-assistant__do_4K","llm-for-insurtech-saas":"styles_llm-for-insurtech-saas__V_fGH","feedback-insight-engine":"styles_feedback-insight-engine__Gc8ks","predictive-ai-for-marketing":"styles_predictive-ai-for-marketing__ElDcr","ai-agent-for-pre-screening":"styles_ai-agent-for-pre-screening__9r_Xx","ai-concierge-for-hotel-network":"styles_ai-concierge-for-hotel-network__BHuwA","ai-voice-assistant-for-e-learning":"styles_ai-voice-assistant-for-e-learning__OTu5V","ai-assistant-for-chronic-patients":"styles_ai-assistant-for-chronic-patients__slXwa","services":"styles_services__JEyOX","imageLink":"styles_imageLink__kJCyz","imageLinkContainer":"styles_imageLinkContainer__vct6N","newhomepage":"styles_newhomepage__iDkXb","ai-warehouse-agent":"styles_ai-warehouse-agent__JBO2k","rag-contract-intelligence-platform":"styles_rag-contract-intelligence-platform__vPmq2","claude-sonnet-leasing-operations-platform":"styles_claude-sonnet-leasing-operations-platform__huXeb","influx":"styles_influx__CLo16","blinking":"styles_blinking__DSwC2","swing":"styles_swing__8JkbR","animateborder":"styles_animateborder__2IrQP","animateborder-overlay":"styles_animateborder-overlay__dVo0b","animatecircle":"styles_animatecircle__kBoKo","animatedot":"styles_animatedot__ov_c6","animStar":"styles_animStar__1JqGW","hideText":"styles_hideText__SrlfN","spin":"styles_spin__WuJ_A","outOfTransparencyDesktop":"styles_outOfTransparencyDesktop__Qsh31","outOfTransparencyMobile":"styles_outOfTransparencyMobile__lBGg1","appearance":"styles_appearance__oW0u7","appearanceFromBelow":"styles_appearanceFromBelow__Enpl9","flicker":"styles_flicker__V4JdY","vibrate1":"styles_vibrate1__UrnGM","rocket":"styles_rocket__9ef6i","burgerItem1":"styles_burgerItem1__CINma","burgerItem2":"styles_burgerItem2__khxX_","burgerItem3":"styles_burgerItem3__21RVM","burgerItem1Reverse":"styles_burgerItem1Reverse__Z9f7s","burgerItem2Reverse":"styles_burgerItem2Reverse__TK2GW","burgerItem3Reverse":"styles_burgerItem3Reverse__p1sdj","arrow-down":"styles_arrow-down__LVlHy","image-scroll":"styles_image-scroll__QJT9h","image-scroll-reverse":"styles_image-scroll-reverse__I23A3","stickerbox-pointer-move":"styles_stickerbox-pointer-move___ZyJT","hide-image":"styles_hide-image__EE38_","stickerbox-pointer-second":"styles_stickerbox-pointer-second__otPr_","stickerbox-pointer-third":"styles_stickerbox-pointer-third____8P6","cedar-bounce":"styles_cedar-bounce__ejRRM"};

/***/ }),

/***/ 70976:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section":"styles_section__RA_Fh","titleStyle":"styles_titleStyle__EeVHb","videoContainer":"styles_videoContainer__7Z0ua","stickerbox":"styles_stickerbox__XcC8Q","firstSectionView":"styles_firstSectionView__fAaj6","secondSectionView":"styles_secondSectionView__26FnN","fireaway":"styles_fireaway__JOv4h","seven-pm-thursday":"styles_seven-pm-thursday__YOF2Y","fernwayer":"styles_fernwayer__KaErA","thirdSectionView":"styles_thirdSectionView__abNOl","drive-focus":"styles_drive-focus__LLerZ","hotel-data-cloud":"styles_hotel-data-cloud__nhhiR","separate-us":"styles_separate-us__Zjtcf","famlicious":"styles_famlicious__wB9SD","natp":"styles_natp__ulY77","ubichat":"styles_ubichat__DlV0I","writer-chrome-extension":"styles_writer-chrome-extension__yySYC","meateater":"styles_meateater__UWs7P","bionorica":"styles_bionorica__zCcay","bundleImage":"styles_bundleImage__0CThz","marketplace-for-clairvoyant-services":"styles_marketplace-for-clairvoyant-services__kvk1F","fusion-markets":"styles_fusion-markets__Gxlre","image":"styles_image__z6QR8","beautonomy":"styles_beautonomy__x2dqn","blackbird":"styles_blackbird__Pt3c_","fintech-app-for-credit-score":"styles_fintech-app-for-credit-score__KokBX","dindon":"styles_dindon__4UPaY","humankind":"styles_humankind__yItPM","cinnabar":"styles_cinnabar__zXrcE","machine-learning-in-real-estate":"styles_machine-learning-in-real-estate__kpJwC","mobile-bank-application":"styles_mobile-bank-application__90K58","software-for-mri-interpretation":"styles_software-for-mri-interpretation__XEX22","textContainer":"styles_textContainer__a7pI9","cedar-valley-farms":"styles_cedar-valley-farms___vaDE","why-us":"styles_why-us__okgux","fourthSectionView":"styles_fourthSectionView__PJ3bA","fifthSectionView":"styles_fifthSectionView__smUaP","sixthSectionView":"styles_sixthSectionView__3Mo95","mobile-budgeting-app":"styles_mobile-budgeting-app__dGm9z","forex-trading-platform":"styles_forex-trading-platform__daqQy","crowdfunding-platform":"styles_crowdfunding-platform__Ocil4","cctv-footage-analytics":"styles_cctv-footage-analytics__Dg61_","web-chat-for-mediums":"styles_web-chat-for-mediums__qjuUK","web-p2p-lending-platform":"styles_web-p2p-lending-platform__dAX1o","kitchen-equipment-customizer":"styles_kitchen-equipment-customizer___Yry0","mobile-music-app":"styles_mobile-music-app__zOX_t","seventhSectionView":"styles_seventhSectionView__HFfbG","digital-wallet-for-ios":"styles_digital-wallet-for-ios__m3_iq","enterprise-resource-planning-system":"styles_enterprise-resource-planning-system__SeQpb","company":"styles_company__SZcLc","enhancing-money-laundering-mention-extraction":"styles_enhancing-money-laundering-mention-extraction__se_H9","computer-vision-for-aras":"styles_computer-vision-for-aras__uHSP9","videoWrapper":"styles_videoWrapper__3o8Uc","videoDescription":"styles_videoDescription__N2Ya1","web-logistics-platform":"styles_web-logistics-platform__QcSr_","llm-legal-document-summarization":"styles_llm-legal-document-summarization__ymkuv","ai-feedback-analysis":"styles_ai-feedback-analysis__5ECXm","ai-for-edtech":"styles_ai-for-edtech__wXvIG","ai-reporting-assistant":"styles_ai-reporting-assistant__8OEzP","llm-for-insurtech-saas":"styles_llm-for-insurtech-saas__NELLA","feedback-insight-engine":"styles_feedback-insight-engine__McePr","predictive-ai-for-marketing":"styles_predictive-ai-for-marketing__AEE1T","ai-agent-for-pre-screening":"styles_ai-agent-for-pre-screening__lhXKx","ai-concierge-for-hotel-network":"styles_ai-concierge-for-hotel-network__Aums3","ai-voice-assistant-for-e-learning":"styles_ai-voice-assistant-for-e-learning__iosia","ai-assistant-for-chronic-patients":"styles_ai-assistant-for-chronic-patients__fX6Z3","services":"styles_services__71Ivw","newhomepage":"styles_newhomepage__jUBUM","ai-warehouse-agent":"styles_ai-warehouse-agent__d6Vf_","rag-contract-intelligence-platform":"styles_rag-contract-intelligence-platform__G6oWL","claude-sonnet-leasing-operations-platform":"styles_claude-sonnet-leasing-operations-platform__Lqcse","influx":"styles_influx__s9K6v"};

/***/ }),

/***/ 31304:
/***/ (function(module) {


;(function (name, root, factory) {
  if (true) {
    module.exports = factory()
    module.exports["default"] = factory()
  }
  /* istanbul ignore next */
  else {}
}('slugify', this, function () {
  var charMap = JSON.parse('{"$":"dollar","%":"percent","&":"and","<":"less",">":"greater","|":"or","¢":"cent","£":"pound","¤":"currency","¥":"yen","©":"(c)","ª":"a","®":"(r)","º":"o","À":"A","Á":"A","Â":"A","Ã":"A","Ä":"A","Å":"A","Æ":"AE","Ç":"C","È":"E","É":"E","Ê":"E","Ë":"E","Ì":"I","Í":"I","Î":"I","Ï":"I","Ð":"D","Ñ":"N","Ò":"O","Ó":"O","Ô":"O","Õ":"O","Ö":"O","Ø":"O","Ù":"U","Ú":"U","Û":"U","Ü":"U","Ý":"Y","Þ":"TH","ß":"ss","à":"a","á":"a","â":"a","ã":"a","ä":"a","å":"a","æ":"ae","ç":"c","è":"e","é":"e","ê":"e","ë":"e","ì":"i","í":"i","î":"i","ï":"i","ð":"d","ñ":"n","ò":"o","ó":"o","ô":"o","õ":"o","ö":"o","ø":"o","ù":"u","ú":"u","û":"u","ü":"u","ý":"y","þ":"th","ÿ":"y","Ā":"A","ā":"a","Ă":"A","ă":"a","Ą":"A","ą":"a","Ć":"C","ć":"c","Č":"C","č":"c","Ď":"D","ď":"d","Đ":"DJ","đ":"dj","Ē":"E","ē":"e","Ė":"E","ė":"e","Ę":"e","ę":"e","Ě":"E","ě":"e","Ğ":"G","ğ":"g","Ģ":"G","ģ":"g","Ĩ":"I","ĩ":"i","Ī":"i","ī":"i","Į":"I","į":"i","İ":"I","ı":"i","Ķ":"k","ķ":"k","Ļ":"L","ļ":"l","Ľ":"L","ľ":"l","Ł":"L","ł":"l","Ń":"N","ń":"n","Ņ":"N","ņ":"n","Ň":"N","ň":"n","Ō":"O","ō":"o","Ő":"O","ő":"o","Œ":"OE","œ":"oe","Ŕ":"R","ŕ":"r","Ř":"R","ř":"r","Ś":"S","ś":"s","Ş":"S","ş":"s","Š":"S","š":"s","Ţ":"T","ţ":"t","Ť":"T","ť":"t","Ũ":"U","ũ":"u","Ū":"u","ū":"u","Ů":"U","ů":"u","Ű":"U","ű":"u","Ų":"U","ų":"u","Ŵ":"W","ŵ":"w","Ŷ":"Y","ŷ":"y","Ÿ":"Y","Ź":"Z","ź":"z","Ż":"Z","ż":"z","Ž":"Z","ž":"z","Ə":"E","ƒ":"f","Ơ":"O","ơ":"o","Ư":"U","ư":"u","ǈ":"LJ","ǉ":"lj","ǋ":"NJ","ǌ":"nj","Ș":"S","ș":"s","Ț":"T","ț":"t","ə":"e","˚":"o","Ά":"A","Έ":"E","Ή":"H","Ί":"I","Ό":"O","Ύ":"Y","Ώ":"W","ΐ":"i","Α":"A","Β":"B","Γ":"G","Δ":"D","Ε":"E","Ζ":"Z","Η":"H","Θ":"8","Ι":"I","Κ":"K","Λ":"L","Μ":"M","Ν":"N","Ξ":"3","Ο":"O","Π":"P","Ρ":"R","Σ":"S","Τ":"T","Υ":"Y","Φ":"F","Χ":"X","Ψ":"PS","Ω":"W","Ϊ":"I","Ϋ":"Y","ά":"a","έ":"e","ή":"h","ί":"i","ΰ":"y","α":"a","β":"b","γ":"g","δ":"d","ε":"e","ζ":"z","η":"h","θ":"8","ι":"i","κ":"k","λ":"l","μ":"m","ν":"n","ξ":"3","ο":"o","π":"p","ρ":"r","ς":"s","σ":"s","τ":"t","υ":"y","φ":"f","χ":"x","ψ":"ps","ω":"w","ϊ":"i","ϋ":"y","ό":"o","ύ":"y","ώ":"w","Ё":"Yo","Ђ":"DJ","Є":"Ye","І":"I","Ї":"Yi","Ј":"J","Љ":"LJ","Њ":"NJ","Ћ":"C","Џ":"DZ","А":"A","Б":"B","В":"V","Г":"G","Д":"D","Е":"E","Ж":"Zh","З":"Z","И":"I","Й":"J","К":"K","Л":"L","М":"M","Н":"N","О":"O","П":"P","Р":"R","С":"S","Т":"T","У":"U","Ф":"F","Х":"H","Ц":"C","Ч":"Ch","Ш":"Sh","Щ":"Sh","Ъ":"U","Ы":"Y","Ь":"","Э":"E","Ю":"Yu","Я":"Ya","а":"a","б":"b","в":"v","г":"g","д":"d","е":"e","ж":"zh","з":"z","и":"i","й":"j","к":"k","л":"l","м":"m","н":"n","о":"o","п":"p","р":"r","с":"s","т":"t","у":"u","ф":"f","х":"h","ц":"c","ч":"ch","ш":"sh","щ":"sh","ъ":"u","ы":"y","ь":"","э":"e","ю":"yu","я":"ya","ё":"yo","ђ":"dj","є":"ye","і":"i","ї":"yi","ј":"j","љ":"lj","њ":"nj","ћ":"c","ѝ":"u","џ":"dz","Ґ":"G","ґ":"g","Ғ":"GH","ғ":"gh","Қ":"KH","қ":"kh","Ң":"NG","ң":"ng","Ү":"UE","ү":"ue","Ұ":"U","ұ":"u","Һ":"H","һ":"h","Ә":"AE","ә":"ae","Ө":"OE","ө":"oe","Ա":"A","Բ":"B","Գ":"G","Դ":"D","Ե":"E","Զ":"Z","Է":"E\'","Ը":"Y\'","Թ":"T\'","Ժ":"JH","Ի":"I","Լ":"L","Խ":"X","Ծ":"C\'","Կ":"K","Հ":"H","Ձ":"D\'","Ղ":"GH","Ճ":"TW","Մ":"M","Յ":"Y","Ն":"N","Շ":"SH","Չ":"CH","Պ":"P","Ջ":"J","Ռ":"R\'","Ս":"S","Վ":"V","Տ":"T","Ր":"R","Ց":"C","Փ":"P\'","Ք":"Q\'","Օ":"O\'\'","Ֆ":"F","և":"EV","ء":"a","آ":"aa","أ":"a","ؤ":"u","إ":"i","ئ":"e","ا":"a","ب":"b","ة":"h","ت":"t","ث":"th","ج":"j","ح":"h","خ":"kh","د":"d","ذ":"th","ر":"r","ز":"z","س":"s","ش":"sh","ص":"s","ض":"dh","ط":"t","ظ":"z","ع":"a","غ":"gh","ف":"f","ق":"q","ك":"k","ل":"l","م":"m","ن":"n","ه":"h","و":"w","ى":"a","ي":"y","ً":"an","ٌ":"on","ٍ":"en","َ":"a","ُ":"u","ِ":"e","ْ":"","٠":"0","١":"1","٢":"2","٣":"3","٤":"4","٥":"5","٦":"6","٧":"7","٨":"8","٩":"9","پ":"p","چ":"ch","ژ":"zh","ک":"k","گ":"g","ی":"y","۰":"0","۱":"1","۲":"2","۳":"3","۴":"4","۵":"5","۶":"6","۷":"7","۸":"8","۹":"9","฿":"baht","ა":"a","ბ":"b","გ":"g","დ":"d","ე":"e","ვ":"v","ზ":"z","თ":"t","ი":"i","კ":"k","ლ":"l","მ":"m","ნ":"n","ო":"o","პ":"p","ჟ":"zh","რ":"r","ს":"s","ტ":"t","უ":"u","ფ":"f","ქ":"k","ღ":"gh","ყ":"q","შ":"sh","ჩ":"ch","ც":"ts","ძ":"dz","წ":"ts","ჭ":"ch","ხ":"kh","ჯ":"j","ჰ":"h","Ṣ":"S","ṣ":"s","Ẁ":"W","ẁ":"w","Ẃ":"W","ẃ":"w","Ẅ":"W","ẅ":"w","ẞ":"SS","Ạ":"A","ạ":"a","Ả":"A","ả":"a","Ấ":"A","ấ":"a","Ầ":"A","ầ":"a","Ẩ":"A","ẩ":"a","Ẫ":"A","ẫ":"a","Ậ":"A","ậ":"a","Ắ":"A","ắ":"a","Ằ":"A","ằ":"a","Ẳ":"A","ẳ":"a","Ẵ":"A","ẵ":"a","Ặ":"A","ặ":"a","Ẹ":"E","ẹ":"e","Ẻ":"E","ẻ":"e","Ẽ":"E","ẽ":"e","Ế":"E","ế":"e","Ề":"E","ề":"e","Ể":"E","ể":"e","Ễ":"E","ễ":"e","Ệ":"E","ệ":"e","Ỉ":"I","ỉ":"i","Ị":"I","ị":"i","Ọ":"O","ọ":"o","Ỏ":"O","ỏ":"o","Ố":"O","ố":"o","Ồ":"O","ồ":"o","Ổ":"O","ổ":"o","Ỗ":"O","ỗ":"o","Ộ":"O","ộ":"o","Ớ":"O","ớ":"o","Ờ":"O","ờ":"o","Ở":"O","ở":"o","Ỡ":"O","ỡ":"o","Ợ":"O","ợ":"o","Ụ":"U","ụ":"u","Ủ":"U","ủ":"u","Ứ":"U","ứ":"u","Ừ":"U","ừ":"u","Ử":"U","ử":"u","Ữ":"U","ữ":"u","Ự":"U","ự":"u","Ỳ":"Y","ỳ":"y","Ỵ":"Y","ỵ":"y","Ỷ":"Y","ỷ":"y","Ỹ":"Y","ỹ":"y","–":"-","‘":"\'","’":"\'","“":"\\\"","”":"\\\"","„":"\\\"","†":"+","•":"*","…":"...","₠":"ecu","₢":"cruzeiro","₣":"french franc","₤":"lira","₥":"mill","₦":"naira","₧":"peseta","₨":"rupee","₩":"won","₪":"new shequel","₫":"dong","€":"euro","₭":"kip","₮":"tugrik","₯":"drachma","₰":"penny","₱":"peso","₲":"guarani","₳":"austral","₴":"hryvnia","₵":"cedi","₸":"kazakhstani tenge","₹":"indian rupee","₺":"turkish lira","₽":"russian ruble","₿":"bitcoin","℠":"sm","™":"tm","∂":"d","∆":"delta","∑":"sum","∞":"infinity","♥":"love","元":"yuan","円":"yen","﷼":"rial","ﻵ":"laa","ﻷ":"laa","ﻹ":"lai","ﻻ":"la"}')
  var locales = JSON.parse('{"bg":{"Й":"Y","Ц":"Ts","Щ":"Sht","Ъ":"A","Ь":"Y","й":"y","ц":"ts","щ":"sht","ъ":"a","ь":"y"},"de":{"Ä":"AE","ä":"ae","Ö":"OE","ö":"oe","Ü":"UE","ü":"ue","ß":"ss","%":"prozent","&":"und","|":"oder","∑":"summe","∞":"unendlich","♥":"liebe"},"es":{"%":"por ciento","&":"y","<":"menor que",">":"mayor que","|":"o","¢":"centavos","£":"libras","¤":"moneda","₣":"francos","∑":"suma","∞":"infinito","♥":"amor"},"fr":{"%":"pourcent","&":"et","<":"plus petit",">":"plus grand","|":"ou","¢":"centime","£":"livre","¤":"devise","₣":"franc","∑":"somme","∞":"infini","♥":"amour"},"pt":{"%":"porcento","&":"e","<":"menor",">":"maior","|":"ou","¢":"centavo","∑":"soma","£":"libra","∞":"infinito","♥":"amor"},"uk":{"И":"Y","и":"y","Й":"Y","й":"y","Ц":"Ts","ц":"ts","Х":"Kh","х":"kh","Щ":"Shch","щ":"shch","Г":"H","г":"h"},"vi":{"Đ":"D","đ":"d"},"da":{"Ø":"OE","ø":"oe","Å":"AA","å":"aa","%":"procent","&":"og","|":"eller","$":"dollar","<":"mindre end",">":"større end"},"nb":{"&":"og","Å":"AA","Æ":"AE","Ø":"OE","å":"aa","æ":"ae","ø":"oe"},"it":{"&":"e"},"nl":{"&":"en"},"sv":{"&":"och","Å":"AA","Ä":"AE","Ö":"OE","å":"aa","ä":"ae","ö":"oe"}}')

  function replace (string, options) {
    if (typeof string !== 'string') {
      throw new Error('slugify: string argument expected')
    }

    options = (typeof options === 'string')
      ? {replacement: options}
      : options || {}

    var locale = locales[options.locale] || {}

    var replacement = options.replacement === undefined ? '-' : options.replacement

    var trim = options.trim === undefined ? true : options.trim

    var slug = string.normalize().split('')
      // replace characters based on charMap
      .reduce(function (result, ch) {
        var appendChar = locale[ch];
        if (appendChar === undefined) appendChar = charMap[ch];
        if (appendChar === undefined) appendChar = ch;
        if (appendChar === replacement) appendChar = ' ';
        return result + appendChar
          // remove not allowed characters
          .replace(options.remove || /[^\w\s$*_+~.()'"!\-:@]+/g, '')
      }, '');

    if (options.strict) {
      slug = slug.replace(/[^A-Za-z0-9\s]/g, '');
    }

    if (trim) {
      slug = slug.trim()
    }

    // Replace spaces with replacement character, treating multiple consecutive
    // spaces as a single space.
    slug = slug.replace(/\s+/g, replacement);

    if (options.lower) {
      slug = slug.toLowerCase()
    }

    return slug
  }

  replace.extend = function (customMap) {
    Object.assign(charMap, customMap)
  }

  return replace
}))


/***/ })

}]);